export default __webpack_public_path__ + "slack-community-icon@2x.png";